export default __webpack_public_path__ + "static/media/profile1.1644a3fd.png";